module.exports = __webpack_public_path__ + "static/media/Consumer_Satisfaction_Results.1a5523d9.pdf";